

import React, { useEffect, useRef, useState } from 'react';
import { AppBar, Toolbar, Typography, Button, Box, TextField, Paper, Container } from '@mui/material';
import './landing.scss';
import logo from '../../assets/logo.png';
import CallIcon from '@mui/icons-material/Call';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useDispatch } from 'react-redux';
import { createContact } from '../../store/contactSlice';
import axios from 'axios';
import PhoneInput from 'react-phone-input-2';
import ReactGA from '../../utils/analytics';
import GooglePlacesAutocomplete from '../../components/Common/GoogleAutoComplete';

const HeroSection = ({ pageDetail }) => {
    const videoRef = useRef(null);
    const dispatch = useDispatch()
    const [info, setInfo] = useState([]);

    useEffect(() => {
        ReactGA.send({ hitType: 'pageview', page: `/${pageDetail.slug}`, title: 'landing Page' });
    }, []);

    useEffect(() => {
        if (videoRef.current) {
            videoRef.current.playbackRate = 0.7;
        }
    }, []);

    // useEffect(() => {
    //     if (window.gtag) {
    //         window.gtag('event', 'page_view', {
    //             page_title: 'About Page',
    //             page_path: window.location.pathname,
    //         });
    //     }
    // }, []);


    useEffect(() => {

        if (pageDetail.slug) {
            axios.get(`${process.env.REACT_APP_API_BASE_URL}/domain/${pageDetail.slug}/slug`, {
                refresh: localStorage.getItem('refreshToken'),
            }).then((response) => {

                if (response.status === 200) {
                    setInfo(response?.data?.data)
                }
            }).catch((error) => {
            })
        }
    }, [pageDetail.slug])


    const formik = useFormik({
        initialValues: {
            name: '',
            phone: '',
            email: '',
            address: '',
            zipcode: '',
            query: '',
        },
        validationSchema: Yup.object({
            name: Yup.string().required('Name is required'),
            phone: Yup.string()
                .matches(/^\+?(\d.*){10,}$/, 'Phone number is not valid')
                .required('Phone number is required'),
            email: Yup.string()
                .required("Email is required")
                .matches(
                    /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                    "Enter a valid email address"
                ),
            address: Yup.string().required('Address is required'),
            query: Yup.string().required('Message is required'),
        }),
        onSubmit: (values, { resetForm }) => {
            const domain = window.location.href;   // Full URL
            const source_slug = window.location.pathname; // Just the path, like '/domain'
            values.landing_page_url = domain
            values.source_slug = source_slug
            dispatch(createContact(values))
            resetForm();
        }
    });
    return (
        <div className="hero-wrapper">
            {info?.photos?.length &&
                <>
                    {info?.photos[0]?.video || info?.photos[0]?.file_type === "video" ? (
                        <video
                            ref={videoRef}
                            autoPlay
                            loop
                            muted
                            playsInline
                            className="background-video"
                        >
                            <source src={info.photos[0].video || info.photos[0].external_url} type="video/mp4" />
                            Your browser does not support the video tag.
                        </video>
                    ) : (
                        <div
                            className="background-image"
                            style={{
                                backgroundImage: `url(${info?.photos[0]?.image || info?.photos[0]?.external_url})`,
                                backgroundSize: 'cover',
                                backgroundPosition: 'center',
                                width: '100%',
                                height: '100%',
                                position: 'absolute',
                                top: 0,
                                left: 0,
                                zIndex: -1,
                            }}
                        ></div>
                    )}
                </>}
            <AppBar position="static" className="custom-navbar">
                <Toolbar className="navbar-toolbar">
                    <Box className="navbar-logo">
                        {/* <img src={logo}  alt="RayIQlive" /> */}
                        <img
                            // className="logo"
                            src={logo}
                            alt="logo"
                            className="mr-3 bg-white drawer-favicon"
                            loading="logo"
                        />
                    </Box>
                    <Typography className="contact-number"><CallIcon />{info.contact}</Typography>
                </Toolbar>
            </AppBar>

            <Container maxWidth="lg" className="hero-container">
                <Box className="hero-content"  >
                    <Box className="left-content"  >
                        <Typography variant="h2" className="hero-title">
                            {info?.title}
                        </Typography>
                        <Typography
                            variant="subtitle1"
                            className="hero-subtitle"
                            dangerouslySetInnerHTML={{ __html: info?.body || '' }}
                        />

                    </Box>
                    <Box sx={{
                        display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column',
                        width: {
                            xs: '100%',   // default for extra-small screens
                            md: '40%',    // 50% width on medium screens and up
                            lg: '40%'     // 50% on large screens (optional since md already covers it)
                        }
                    }}>
                        <Paper elevation={7} className="right-form" sx={{ width: '100%' }}>
                            <Typography variant="h5" className="form-title">
                                Contact Us
                            </Typography>
                            <Box
                                component="form"
                                onSubmit={formik.handleSubmit}
                                className="form-fields"
                            >
                                <TextField
                                    fullWidth
                                    id="name"
                                    name="name"
                                    label="Name"
                                    required
                                    placeholder="Name"
                                    size="small"
                                    variant="outlined"
                                    margin="normal"
                                    value={formik.values.name}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    error={formik.touched.name && Boolean(formik.errors.name)}
                                    helperText={formik.touched.name && formik.errors.name}
                                />
                                {/* <TextField
                                fullWidth
                                id="phone"
                                name="phone"
                                required
                                label="Phone"
                                placeholder="+1 (555) 000-0000"
                                size="small"
                                variant="outlined"
                                margin="normal"
                                value={formik.values.phone}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                error={formik.touched.phone && Boolean(formik.errors.phone)}
                                helperText={formik.touched.phone && formik.errors.phone}
                            /> */}
                                <Box sx={{ mt: 1.5 }}>
                                    <PhoneInput
                                        country={'us'}
                                        value={formik.values.phone}
                                        onChange={(value, countryData, e, formattedValue) => {
                                            // value = national number (e.g., 4155552671)
                                            // countryData.dialCode = '1' for US
                                            formik.setFieldValue('phone', formattedValue);
                                        }}
                                        placeholder="Enter phone number"
                                        inputProps={{
                                            name: 'phone',
                                            required: true,
                                            autoFocus: false,
                                            onBlur: formik.handleBlur, // Important to trigger validation on blur
                                        }}
                                        inputStyle={{
                                            width: '100%',
                                            marginTop: '16px',
                                            marginBottom: '8px',
                                            // padding: '10px',
                                            height: '40px',
                                            borderRadius: '4px',
                                            // backgroundColor: '#FAFBF8',
                                            background: 'none',
                                            border: formik.touched.phone && formik.errors.phone
                                                ? '1px solid #dc3545'
                                                : '1px solid #b9b3b3',
                                        }}
                                        containerStyle={{
                                            marginBottom: '16px',
                                        }}
                                    />
                                </Box>
                                {formik.touched.phone && formik.errors.phone && (
                                    <div style={{ color: '#dc3545', marginTop: '-12px', marginBottom: '0px', fontSize: '12px' }}>
                                        {formik.errors.phone}
                                    </div>
                                )}
                                <TextField
                                    fullWidth
                                    id="email"
                                    required
                                    name="email"
                                    label="Email"
                                    placeholder="your@email.com"
                                    size="small"
                                    variant="outlined"
                                    className="mt-1"
                                    margin="normal"
                                    value={formik.values.email}
                                    // onChange={formik.handleChange}
                                    onChange={(e) => {
                                        const lowerCaseEmail = e.target.value.toLowerCase();
                                        formik.setFieldValue("email", lowerCaseEmail);
                                    }}
                                    onBlur={formik.handleBlur}
                                    error={formik.touched.email && Boolean(formik.errors.email)}
                                    helperText={formik.touched.email && formik.errors.email}
                                />
                                {/* <TextField
                                    fullWidth
                                    required
                                    id="address"
                                    name="address"
                                    label="Address"
                                    placeholder="Address"
                                    size="small"
                                    variant="outlined"
                                    margin="normal"
                                    value={formik.values.address}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    error={formik.touched.address && Boolean(formik.errors.address)}
                                    helperText={formik.touched.address && formik.errors.address}
                                /> */}
                                <GooglePlacesAutocomplete
                                    className={"mt-3 mb-2"}
                                    size={"small"}
                                    required={true}
                                    onPlaceSelect={(place) => console.log(place)}
                                    value={formik.values.address}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    formik={formik}
                                    name="address"
                                    error={formik.touched.address && Boolean(formik.errors.address)}
                                    helperText={formik.touched.address && formik.errors.address}
                                />

                                <TextField
                                    fullWidth
                                    id="query"
                                    name="query"
                                    required
                                    label="What can we help you with?"
                                    placeholder="What can we help you with?"
                                    multiline
                                    minRows={4}
                                    maxRows={4}
                                    size="small"
                                    variant="outlined"
                                    margin="normal"
                                    value={formik.values.query}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    error={formik.touched.query && Boolean(formik.errors.query)}
                                    helperText={formik.touched.query && formik.errors.query}
                                />

                                <Button
                                    type="submit"
                                    variant="contained"
                                    fullWidth
                                    className="mt-3"
                                    disabled={!(formik.dirty && formik.isValid) || formik.isSubmitting}
                                >
                                    Submit
                                </Button>
                            </Box>
                        </Paper>
                        {/* <Typography sx={{color:'#cfcfcf', mt:1.5, textShadow: '1px 1px 2px rgba(0, 0, 0, 0.5)',}} className='d-flex gap-2' justifyContent={"center"} gap={1} alignItems={"center"} >
                            <small className='mt-1'> © {new Date().getFullYear()} Rayiq Live. All rights reserved.</small>
                            <a href="/privacy-policy" target="_blank" rel="noopener noreferrer" style={{ color: "inherit", textDecoration: 'underline' }}>
                                <Typography color='#ace734e8' > <small>Privacy Policy</small> </Typography>
                            </a>
                            <a href="/terms-conditions" target="_blank" rel="noopener noreferrer" style={{ color: "inherit", textDecoration: 'underline' }}>
                                <Typography color='#ace734e8' > <small>T&C</small> </Typography>
                            </a>
                        </Typography> */}
                    </Box>
                </Box>
            </Container>
            <Box
                className='landing-page-footer'
                component="footer" >
                <Typography color="textSecondary" className='d-flex gap-2' justifyContent={"center"} gap={1} alignItems={"center"} >
                    <small className='mt-1'> Rayiq Live © {new Date().getFullYear()}  All rights reserved.</small>
                    <a href="/privacy-policy" target="_blank" rel="noopener noreferrer" style={{ color: "inherit", textDecoration: 'underline' }}>
                        <Typography color="inherit"  > <small>Privacy Policy</small> </Typography>
                    </a>
                    <a href="/terms-conditions" target="_blank" rel="noopener noreferrer" style={{ color: "inherit", textDecoration: 'underline' }}>
                        <Typography  > <small>T&C</small> </Typography>
                    </a>
                </Typography>
            </Box>
        </div>
    );
};

export default HeroSection;
